export default __webpack_public_path__ + "static/media/work-time.056843a8.svg";